import { Tag } from '~/components/tag'
import type { TTagProps } from '~/components/tag/types'

type ProductHeaderTagProps = Pick<TTagProps, 'testID'>

export const ProductHeaderTag = ({ testID }: ProductHeaderTagProps) => {
  return (
    <Tag.Root variant="patrocinado" testID={testID}>
      <Tag.Label>Patrocinado</Tag.Label>
    </Tag.Root>
  )
}
